/*
 * bnh-cart-edit.js
 * ----------------------------------------------------------------------------
 * Lets a customer EDIT a customised cart line (letter, pouch colour, strap...).
 *
 * Why not edit the properties in place?
 *   /cart/change.js can update `properties`, but the add-on PRICING for those
 *   options is owned by the OPTIS (BSS) product-options app. Rewriting the
 *   property value alone would change the selection without repricing it, so a
 *   paid option could be swapped in for free. Instead we send the customer back
 *   to the product page - where OPTIS's own UI reprices correctly - and remove
 *   the superseded line only once the replacement has actually been added.
 *
 * Flow:
 *   1. "Düzenle" links to the product with ?edit_key=<line key>.
 *   2. We remember that key for the session.
 *   3. On the next successful /cart/add, we delete the old line and refresh.
 *   If the customer never adds anything, nothing is lost - the original line
 *   stays in the cart exactly as it was.
 */
(function () {
  'use strict';

  var STORE_KEY = 'bnh:editLineKey';

  function remember(k) { try { sessionStorage.setItem(STORE_KEY, k); } catch (e) {} }
  function pending()   { try { return sessionStorage.getItem(STORE_KEY); } catch (e) { return null; } }
  function forget()    { try { sessionStorage.removeItem(STORE_KEY); } catch (e) {} }

  try {
    var key = new URLSearchParams(window.location.search).get('edit_key');
    if (key) remember(key);
  } catch (e) {}

  function refreshDrawer() {
    var mc = document.getElementById('mini-cart');
    var host = document.querySelector('mini-cart');
    if (!mc || !host || !host.dataset || !host.dataset.url) return;
    window.fetch(host.dataset.url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var sec = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
        if (sec) mc.innerHTML = sec.innerHTML;
        document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(function () {});
  }

  function dropSupersededLine() {
    var lineKey = pending();
    if (!lineKey) return;
    forget();
    window.fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    })
      .then(function () {
        refreshDrawer();
        document.dispatchEvent(new CustomEvent('bnh:cart-line-replaced'));
      })
      .catch(function () {});
  }

  /* ------------------------------------------------------------------
   * Accessory lines added by bnh-addons carry properties._bnh_parent.
   * Shopify returns cart lines in its own order, so a child can end up
   * ABOVE its parent. Reorder the rendered DOM so each child sits directly
   * beneath the item it belongs to. Purely visual - the cart is untouched.
   * ---------------------------------------------------------------------- */
  function nestChildLines(root) {
    var scope = root || document;
    var children = scope.querySelectorAll('[data-bnh-parent]');
    children.forEach(function (child) {
      var parentId = child.getAttribute('data-bnh-parent');
      if (!parentId) return;
      var list = child.parentElement;
      if (!list) return;
      var parent = list.querySelector('[data-variant-id="' + parentId + '"]:not([data-bnh-parent])');
      if (!parent || parent === child) return;

      // place after the parent and after any siblings already nested under it
      var anchorEl = parent;
      var next = anchorEl.nextElementSibling;
      while (next && next.getAttribute && next.getAttribute('data-bnh-parent') === parentId) {
        anchorEl = next;
        next = anchorEl.nextElementSibling;
      }
      if (anchorEl.nextElementSibling !== child) {
        anchorEl.parentNode.insertBefore(child, anchorEl.nextElementSibling);
      }
    });
  }

  document.addEventListener('cartdrawer:opened', function () { nestChildLines(); });
  document.addEventListener('DOMContentLoaded', function () { nestChildLines(); });
  if (document.readyState !== 'loading') nestChildLines();
  window.bnhNestChildLines = nestChildLines;

  function isCartAdd(url) {
    return typeof url === 'string' && url.indexOf('/cart/add') !== -1;
  }

  // Observe adds without interfering with them: the original promise/handlers
  // are always returned untouched, we only listen for success.
  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var result = nativeFetch.apply(this, arguments);
    if (isCartAdd(url) && pending()) {
      result.then(function (res) { if (res && res.ok) dropSupersededLine(); })
            .catch(function () {});
    }
    return result;
  };

  // Some apps (OPTIS included) add to cart over XHR rather than fetch.
  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__bnhCartAdd = isCartAdd(url);
    return nativeOpen.apply(this, arguments);
  };
  var nativeSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this.__bnhCartAdd) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300 && pending()) dropSupersededLine();
      });
    }
    return nativeSend.apply(this, arguments);
  };
})();
